declare global {
  interface Window {
    env?: {
      REACT_APP_ENDPOINT: string
      REACT_APP_MOCK_ENDPOINT: string
      REACT_APP_API_VERSION: string
      REACT_APP_GA_TRACKING_ID: string
    }
  }
}

const getEnvVar = (key: string) => {
  if (typeof window !== 'undefined' && window.env && window.env[`REACT_APP_${key}`]) {
    return window.env[`REACT_APP_${key}`]!
  }
  return process.env[`REACT_APP_${key}`]!
}

export const IS_DEV = process.env.NODE_ENV === 'development'
export const IS_PROD = process.env.NODE_ENV === 'production'
export const IS_TEST = process.env.NODE_ENV === 'test'
export const ENDPOINT = getEnvVar('ENDPOINT')
export const MOCK_ENDPOINT = getEnvVar('MOCK_ENDPOINT')
export const API_VERSION = getEnvVar('API_VERSION')
export const GA_TRACKING_ID = getEnvVar('GA_TRACKING_ID')
export const CLARITY_ID = getEnvVar('CLARITY_ID')



// WEBPACK FOOTER //
// ./src/environment.ts